export interface Page<T = any> {
  current: number;
  size: number;
  total: number;
  records: T[];
}

export function firstPage<T>(): Page<T> {
  return {
    current: 1,
    size: 10,
    total: 0,
    records: [],
  };
}
